import React, { useState, useRef, useEffect } from "react";
import { RxCaretRight } from "react-icons/rx";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./MainLayout.scss";

const MainLayout = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const asideRef = useRef(null);
  const mainContentRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      // Desktop: open by default, Mobile: closed by default
      setOpen(!mobile);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setOpen(!isOpen);
  };

  const handleMobileNavClick = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  return (
    <div className="main-layout bg-gradient-to-br from-light_orange to-orange-50">
      {/* Header Area */}
      <Header />

      <div className="content-wrapper">
        {/* Mobile Overlay */}
        {isMobile && isOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setOpen(false)}
          />
        )}

        {/* Sidebar Area */}
        <aside
          ref={asideRef}
          className={`sidebar shadow-2xl ${isOpen ? "sidebar-open" : "sidebar-close"}`}
        >
          {/* Desktop Toggle Button */}
          {!isMobile && (
            <RxCaretRight 
              className={`toggle-icon transform transition-all duration-300 hover:scale-110 hover:shadow-lg ${
                isOpen ? 'rotate-180' : ''
              }`} 
              onClick={toggleSidebar} 
            />
          )}
          <div className="sidebar-content overflow-hidden">
            <Sidebar onMobileNavClick={handleMobileNavClick} />
          </div>
        </aside>

        {/* Mobile Toggle Button - Always Visible */}
        {isMobile && (
          <RxCaretRight 
            className={`toggle-icon transform transition-all duration-300 hover:scale-110 hover:shadow-lg ${
              isOpen ? 'rotate-180' : ''
            }`} 
            onClick={toggleSidebar} 
          />
        )}


        {/* Main Content Area */}
        <main
          className={`main-content backdrop-blur-sm ${
            isOpen ? "main-content-close" : "main-content-open"
          }`}
          ref={mainContentRef}
        >
          <div className="animate-fadeIn">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;